import { createContext, useContext } from "react";

const BrowserTabContext = createContext({});

export const BrowserTabContextProvider = BrowserTabContext.Provider;
export const BrowserTabContextConsumer = BrowserTabContext.Consumer;

export const useBrowserTabContext = () => useContext(BrowserTabContext);

export default BrowserTabContext;
